import { TYPOGRAPHY } from "../constants/theme"

export const modalStyles = {
	overlay: {
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 1000,
	},
	container: {
		backgroundColor: "white",
		borderRadius: "8px",
		padding: "24px",
		width: "90%",
		maxWidth: "600px",
		maxHeight: "80vh",
		overflow: "auto",
		boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
	},
	header: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: "20px",
	},
	title: {
		margin: 0,
		fontSize: TYPOGRAPHY.fontSize.lg,
		fontWeight: "600",
	},
	closeButton: {
		background: "none",
		border: "none",
		fontSize: TYPOGRAPHY.fontSize.xl,
		cursor: "pointer",
		color: "#666",
		padding: "0",
	},
}

export const searchStyles = {
	container: {
		marginBottom: "20px",
	},
	label: {
		display: "block",
		marginBottom: "8px",
		fontSize: TYPOGRAPHY.fontSize.sm,
		fontWeight: "500",
	},
	inputContainer: {
		display: "flex",
		gap: "8px",
	},
}

export const searchResultsStyles = {
	container: {
		marginBottom: "20px",
	},
	resultsContainer: {
		border: "1px solid #d1d5db",
		borderRadius: "8px",
		maxHeight: "350px",
		overflowY: "auto",
		backgroundColor: "#fafafa",
	},
	noResults: {
		border: "1px solid #d1d5db",
		borderRadius: "8px",
		padding: "32px",
		textAlign: "center",
		backgroundColor: "#fafafa",
	},
	noResultsIcon: {
		fontSize: TYPOGRAPHY.fontSize["2xl"],
		marginBottom: "8px",
		display: "block",
	},
	noResultsTitle: {
		fontSize: TYPOGRAPHY.fontSize.md,
		color: "#6b7280",
		marginBottom: "8px",
	},
	noResultsText: {
		fontSize: TYPOGRAPHY.fontSize.sm,
		color: "#9ca3af",
	},
	noResultsHint: {
		fontSize: TYPOGRAPHY.fontSize.xs,
		color: "#9ca3af",
		marginTop: "8px",
	},
}

export const userCardStyles = {
	container: {
		padding: "16px",
		margin: "8px",
		borderRadius: "8px",
		border: "1px solid #e5e7eb",
		cursor: "pointer",
		position: "relative",
	},
	indexBadge: {
		position: "absolute",
		top: "8px",
		right: "12px",
		color: "white",
		borderRadius: "50%",
		width: "24px",
		height: "24px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: TYPOGRAPHY.fontSize.xs,
		fontWeight: "600",
	},
	memberSection: {
		marginBottom: "12px",
		paddingRight: "36px",
	},
}

export const memberDataStyles = {
	header: {
		fontWeight: "700",
		fontSize: TYPOGRAPHY.fontSize.md,
		color: "#1f2937",
		marginBottom: "6px",
		display: "flex",
		alignItems: "center",
		gap: "8px",
	},
	badge: {
		backgroundColor: "#f3f4f6",
		padding: "4px 8px",
		borderRadius: "12px",
		fontSize: TYPOGRAPHY.fontSize.sm,
		fontWeight: "600",
	},
	name: {
		fontSize: TYPOGRAPHY.fontSize.sm,
		fontWeight: "600",
		marginLeft: "32px",
		color: "#374151",
	},
	id: {
		fontSize: TYPOGRAPHY.fontSize.xs,
		color: "#6b7280",
		marginLeft: "32px",
		marginTop: "2px",
	},
	contact: {
		fontSize: TYPOGRAPHY.fontSize.xs,
		color: "#6b7280",
		marginTop: "4px",
		marginLeft: "32px",
		display: "flex",
		alignItems: "center",
	},
}

export const customerDataStyles = {
	container: {
		marginTop: "12px",
		paddingTop: "12px",
		paddingRight: "36px",
		borderTop: "2px solid #e5e7eb",
		backgroundColor: "#f8fffe",
		borderRadius: "6px",
		padding: "12px",
		margin: "0 -4px",
	},
	header: {
		fontWeight: "700",
		fontSize: TYPOGRAPHY.fontSize.md,
		color: "#059669",
		marginBottom: "6px",
		display: "flex",
		alignItems: "center",
		gap: "8px",
	},
	badge: {
		// backgroundColor: "#d1fae5",
		padding: "4px 8px",
		borderRadius: "12px",
		fontSize: TYPOGRAPHY.fontSize.sm,
		fontWeight: "600",
		color: "#059669",
	},
	name: {
		fontSize: TYPOGRAPHY.fontSize.sm,
		fontWeight: "600",
		marginLeft: "32px",
		color: "#374151",
	},
	id: {
		fontSize: TYPOGRAPHY.fontSize.xs,
		color: "#6b7280",
		marginLeft: "32px",
		marginTop: "2px",
	},
	contact: {
		fontSize: TYPOGRAPHY.fontSize.xs,
		color: "#6b7280",
		marginTop: "4px",
		marginLeft: "32px",
		display: "flex",
		alignItems: "center",
		gap: "6px",
	},
	planBadge: {
		fontSize: TYPOGRAPHY.fontSize.xs,
		color: "#059669",
		marginTop: "6px",
		marginLeft: "32px",
		fontWeight: "600",
		display: "flex",
		alignItems: "center",
		gap: "6px",
		// backgroundColor: "#dcfce7",
		padding: "6px 8px",
		borderRadius: "6px",
		width: "fit-content",
	},
	noSubscription: {
		marginTop: "12px",
		paddingTop: "12px",
		paddingRight: "36px",
		borderTop: "2px solid #e5e7eb",
		backgroundColor: "#fafafa",
		borderRadius: "6px",
		padding: "12px",
		margin: "0 -4px",
	},
	noSubscriptionText: {
		fontSize: TYPOGRAPHY.fontSize.sm,
		color: "#9ca3af",
		fontStyle: "italic",
		marginLeft: "32px",
		display: "flex",
		alignItems: "center",
		gap: "8px",
	},
	noSubscriptionBadge: {
		backgroundColor: "#e5e7eb",
		padding: "4px 8px",
		borderRadius: "12px",
		fontSize: TYPOGRAPHY.fontSize.xs,
		fontWeight: "500",
	},
}

export const selectedUserStyles = {
	container: {
		border: "1px solid #0284c7",
		borderRadius: "8px",
		backgroundColor: "#f0f9ff",
		padding: "16px",
		boxShadow: "0 2px 8px rgba(2, 132, 199, 0.15)",
		position: "relative",
	},
	badge: {
		position: "absolute",
		top: "8px",
		right: "12px",
		backgroundColor: "#10b981",
		color: "white",
		borderRadius: "12px",
		padding: "4px 8px",
		fontSize: TYPOGRAPHY.fontSize.xs,
		fontWeight: "600",
	},
	memberSection: {
		marginBottom: "12px",
		paddingRight: "80px",
	},
	customerSection: {
		marginTop: "12px",
		paddingTop: "12px",
		paddingRight: "80px",
		borderTop: "2px solid #e5e7eb",
		backgroundColor: "#f8fffe",
		borderRadius: "6px",
		padding: "12px",
		margin: "0 -4px",
	},
	noSubscription: {
		marginTop: "12px",
		paddingTop: "12px",
		paddingRight: "80px",
		borderTop: "2px solid #e5e7eb",
		backgroundColor: "#fafafa",
		borderRadius: "6px",
		padding: "12px",
		margin: "0 -4px",
	},
}

export const planSelectionStyles = {
	container: {
		marginBottom: "20px",
	},
	label: {
		display: "block",
		marginBottom: "8px",
		fontSize: TYPOGRAPHY.fontSize.sm,
		fontWeight: "500",
	},
}

export const actionButtonsStyles = {
	container: {
		display: "flex",
		justifyContent: "flex-end",
		gap: "12px",
	},
	cancelButton: {
		padding: "10px 20px",
		border: "1px solid #d1d5db",
		borderRadius: "6px",
		backgroundColor: "white",
		color: "#374151",
		cursor: "pointer",
		fontSize: TYPOGRAPHY.fontSize.sm,
	},
}
